var map = {
	"./10_lata60.jpg": 6352,
	"./11_lata60.jpg": 9243,
	"./12_lata60.jpg": 6514,
	"./13_lata70.jpg": 2940,
	"./14_lata70.jpg": 5408,
	"./15_lata70.jpg": 738,
	"./16_1986.jpg": 9551,
	"./17_1986.jpg": 1232,
	"./18_1976.jpg": 988,
	"./19_1992.jpg": 1461,
	"./1_historia_mikolajowa.jpg": 6138,
	"./20_1992.jpg": 2164,
	"./21_1992.jpg": 7489,
	"./22_1995.jpg": 4054,
	"./23_1995.jpg": 4678,
	"./24_1995.jpg": 2688,
	"./25_2010.jpg": 4983,
	"./26_2010.jpg": 8755,
	"./27_2010.jpg": 5595,
	"./28_2022.jpg": 7188,
	"./29_2022.jpg": 4188,
	"./2_historia_mikolajowa.jpg": 4814,
	"./30_2022.jpg": 9212,
	"./31_przyszlosc.jpg": 3945,
	"./32_przyszlosc.jpg": 2903,
	"./33_przyszlosc.jpg": 3504,
	"./3_historia_mikolajowa.jpg": 129,
	"./4_XVIIIw.jpg": 5855,
	"./5_XVIIIw..jpg": 3764,
	"./6_XVIIIw.jpg": 2383,
	"./7_1945.jpg": 6438,
	"./8_1945.jpg": 5684,
	"./9_1945.jpg": 1274,
	"assets/img/samples/10_lata60.jpg": 6352,
	"assets/img/samples/11_lata60.jpg": 9243,
	"assets/img/samples/12_lata60.jpg": 6514,
	"assets/img/samples/13_lata70.jpg": 2940,
	"assets/img/samples/14_lata70.jpg": 5408,
	"assets/img/samples/15_lata70.jpg": 738,
	"assets/img/samples/16_1986.jpg": 9551,
	"assets/img/samples/17_1986.jpg": 1232,
	"assets/img/samples/18_1976.jpg": 988,
	"assets/img/samples/19_1992.jpg": 1461,
	"assets/img/samples/1_historia_mikolajowa.jpg": 6138,
	"assets/img/samples/20_1992.jpg": 2164,
	"assets/img/samples/21_1992.jpg": 7489,
	"assets/img/samples/22_1995.jpg": 4054,
	"assets/img/samples/23_1995.jpg": 4678,
	"assets/img/samples/24_1995.jpg": 2688,
	"assets/img/samples/25_2010.jpg": 4983,
	"assets/img/samples/26_2010.jpg": 8755,
	"assets/img/samples/27_2010.jpg": 5595,
	"assets/img/samples/28_2022.jpg": 7188,
	"assets/img/samples/29_2022.jpg": 4188,
	"assets/img/samples/2_historia_mikolajowa.jpg": 4814,
	"assets/img/samples/30_2022.jpg": 9212,
	"assets/img/samples/31_przyszlosc.jpg": 3945,
	"assets/img/samples/32_przyszlosc.jpg": 2903,
	"assets/img/samples/33_przyszlosc.jpg": 3504,
	"assets/img/samples/3_historia_mikolajowa.jpg": 129,
	"assets/img/samples/4_XVIIIw.jpg": 5855,
	"assets/img/samples/5_XVIIIw..jpg": 3764,
	"assets/img/samples/6_XVIIIw.jpg": 2383,
	"assets/img/samples/7_1945.jpg": 6438,
	"assets/img/samples/8_1945.jpg": 5684,
	"assets/img/samples/9_1945.jpg": 1274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6452;